import OrderApi from '@apis/order/OrderApi';
import { createQueryKeys } from '@lukemorales/query-key-factory';

const orderQueries = createQueryKeys('orders', {
  receipt: (orderId: string) => ({
    queryKey: ['receipt', orderId],
    queryFn: () => OrderApi.getReceipt(orderId),
  }),
  recent: () => ({
    queryKey: ['recent'],
    queryFn: () => OrderApi.getRecentOrders(),
  }),
  orderAble: (orderNo: string) => ({
    queryKey: ['orderAble', orderNo],
    queryFn: () => OrderApi.getOrderAble(orderNo),
  }),
});

export default orderQueries;
